import React from 'react';
import {Text, type TextProps} from '@tempo/core';

const Description: React.FC<TextProps> = ({children, ...props}) => (
	<Text
		variant="body.l.default"
		color="text.neutral.secondary.default"
		mb="spacing.xl"
		{...props}
	>
		{children}
	</Text>
);

export default Description;
